import DraggableArea from './DraggableArea'
import css from './ItemImages.module.scss'
import Dropzone from 'react-dropzone'
import S3 from 'react-aws-s3'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
// import Swiper from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Scrollbar } from 'swiper'
import { toast } from 'react-toastify'
import { handleToast } from 'src/slices/utils'

window.Buffer = window.Buffer || require('buffer').Buffer

export default function ItemImages({ images, setImages, updateFunction, allowUpload = true }) {
	const config = {
		bucketName: 'carty-app',
		region: 'us-east-1',
		accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
		secretAccessKey: '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',
		s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
	}

	const handleImageDrop = acceptedFiles => {
		if (!['image/jpeg', 'image/png'].includes(acceptedFiles[0]?.type)) {
			toast.warning('Only .png and .jpg files are accepted')
			return
		}
		const ReactS3Client = new S3(config)

		const uploadImage = ReactS3Client.uploadFile(acceptedFiles[0], acceptedFiles[0].name).then(
			data => {
				setImages([...images, data.location])
				updateFunction([...images, data.location])
			}
		)

		handleToast(uploadImage, {
			isSuccess: { message: 'Image Uploaded!' },
			isError: { message: 'Image could not be uploaded, please try again.' },
			isLoading: { message: `Uploading...` },
		})
	}

	const removeImage = removedImage => {
		setImages(images.filter(image => image != removedImage))

		updateFunction(images.filter(image => image != removedImage))
		// toast.success('Image removed!')
	}

	const acceptableFormats = ['image/jpeg', 'image/png']
	return (
		// <div className={css["wrapper"]}>
		// <h5>Images</h5>
		<Swiper
			style={{
				margin: '0 -5%',
				padding: '16px 5%',
			}}
			scrollbar={{
				hide: false,
				// dragClass: "swiper-scrollbar-drag" + " " + css["drag"]
			}}
			slidesPerView={'auto'}
			spaceBetween={24}
			modules={[Scrollbar]}
			grabCursor={true}>
			{/* <div className={css["slider"]}> */}
			{/* <p>{JSON.stringify(images)}</p> */}
			{/* <DraggableArea
            componentPropsList={images}
            component={<img className={css["image"]} height="120px" width="120px" />}
         /> */}

			{images?.map(image => {
				return (
					<SwiperSlide
						style={{ width: 'auto' }}
						key={image}>
						<div
							className={css['image']}
							key={image}>
							<img
								height='120px'
								width='120px'
								src={image}
								alt='Uploading...'
							/>
							<i
								className={`fa fa-trash-alt ${css['icon']}`}
								onClick={() => removeImage(image)}
							/>
						</div>
					</SwiperSlide>
				)
			})}
			{allowUpload && (
				<SwiperSlide
					style={{ width: 'auto' }}
					key='upload'>
					<Dropzone
						accept={['image/jpeg', 'image/png']}
						onDrop={acceptedFiles => handleImageDrop(acceptedFiles)}
						onDropRejected={() =>
							toast.error(
								"This file can't be uploaded. Please try again with another image."
							)
						}>
						{({ getRootProps, getInputProps }) => (
							<div
								{...getRootProps()}
								className={css['upload']}>
								<input {...getInputProps()} />
								<i className='fa fa-plus' />
								<span>Upload</span>
							</div>
						)}
					</Dropzone>
				</SwiperSlide>
			)}
		</Swiper>
		// {/* </div> */}
		// </div>
	)
}
